document.addEventListener('DOMContentLoaded', ()=>{
    var Myswiper = new Swiper(".WrapperCustomer__ReviewsInitiate.swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop:true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('.Verified_LogoINit .StickySvgIcon')) {
      e.preventDefault();
      document.body.classList.add("hsa-popup-open");
      document.querySelector(".hsapopupContainer").classList.add("active-open");
    }
  });
  document.addEventListener('click', function(e) {
    if (e.target.closest('.hsapopupContainer .hsaCrsBtn')) {
      e.preventDefault();
      document.body.classList.remove("hsa-popup-open");
      document.querySelector(".hsapopupContainer").classList.remove("active-open");
    }
  });
})

